/* eslint-disable @typescript-eslint/no-explicit-any */

export const defaultSortType = (
	rowA: { values: { [key: string]: any } },
	rowB: { values: { [key: string]: any } },
	columnId: string
): number => {
	const a = rowA.values[columnId]?.toString().toLowerCase() || ''
	const b = rowB.values[columnId]?.toString().toLowerCase() || ''
	if (a > b) return 1
	if (a < b) return -1
	return 0
}
